import React, { ComponentProps } from 'react';
import { SingleComboBox } from '@itandi/itandi-bb-ui';
import { useFormContext } from 'react-hook-form';
import { DealSearchCondition } from '~/models/Deal';
import { useStaffs } from '~/hooks/useStaffs';
import { Staff } from '~/models/Staff';

type Props = {
  dealSearchCondition: DealSearchCondition;
};

export const StaffCombobox: React.FC<Props> = ({
  dealSearchCondition
}: Props) => {
  const { data: staffs } = useStaffs().index();
  const { setValue } = useFormContext<DealSearchCondition>();
  const selectedStaff =
    staffs?.find(({ id }) => id === dealSearchCondition.staffId) || null;
  const [selectedStaffOption] = React.useState<
    ComponentProps<typeof SingleComboBox>['value'] | null
  >(
    selectedStaff
      ? {
          label: selectedStaff.name,
          value: String(selectedStaff.id)
        }
      : null
  );
  const onChangeStaff = React.useCallback(
    async (
      option: ComponentProps<typeof SingleComboBox>['value'] | null
    ): Promise<void> => {
      setValue('staffId', option ? Number(option.value) : undefined);
    },
    [setValue]
  );
  if (staffs === null) {
    return null;
  }
  return (
    <SingleComboBox
      defaultValue={selectedStaffOption || null}
      onChange={onChangeStaff}
      options={staffs.map((c: Staff) => ({
        label: c.name,
        value: String(c.id)
      }))}
      placeholder="担当者"
    />
  );
};
